<template>
  <h1
    class="sticky top-0 z-50 text-center xs:text-xl sm:text-2xl md:text-3xl lg:text-4xl text-teal-900 font-bold border-b-2 shadow-xl border-slate-400 m-8 p-4 bg-blue-50 rounded-b-2xl whitespace-nowrap"
  >
    Top 10 fastest cars 🚗 in the World 🗺️
  </h1>
</template>

<script>
export default {}
</script>
